/** Dataspace details and environment variables. */

export default {
	dataspace: {
		empty: {
			title: "Noch keine Dataspaces",
			hint: "Erstellen Sie einen Dataspace, um loszulegen.",
		},
		create: "Dataspace erstellen",
		created: "{name} erstellt.",
		deleted: "{name} gelöscht.",
		deleteConfirm: "{name} löschen?",
		deleteNote:
			"Seine Prozesse und deren gespeicherter Zustand werden mit gelöscht. Das lässt sich nicht rückgängig machen.",
		noResults: {
			title: "Keine passenden Dataspaces",
			hint: "Nichts passt zu dieser Suche. Versuchen Sie einen anderen Begriff, oder setzen Sie die Suche zurück.",
		},
		column: {
			dataspace: "Dataspace",
			updated: "Aktualisiert",
		},
		meta: {
			members: "Mitglieder",
			created: "Erstellt",
			updated: "Aktualisiert",
		},
		settings: {
			general: "Allgemein",
			environment: "Umgebung",
			telephony: "Telefonie",
		},
		search: "Dataspaces suchen…",
		resultCount: "{n} von {total}",
		openDesigner: "Designer öffnen",
		version: "Projektversion",
		versionHelp:
			"Laufen kann nur eine Version, die auf diesem Server gebaut ist. wip folgt dem Projekt, während es bearbeitet wird.",
		versionWip: "wip — das Projekt, wie es gerade ist",
		versionRelease: "v{version}",
		versionReleaseTitled: "v{version} — {title}",
		versionCurrent: "{version} (kein Build mehr)",
		versionNotBuilt:
			"Version {version} hat auf diesem Server keinen Build und kann daher nicht laufen. Wählen Sie eine andere Version.",
		project: "Projekt",
		details: "Details",
		delete: "Dataspace löschen",
		removeMemberConfirm: "{name} aus diesem Dataspace entfernen?",
		members: {
			remove: "{name} entfernen",
			removed: "{name} entfernt.",
			removeNote:
				"Der Zugriff auf diesen Dataspace und seine Prozesse geht verloren. Eine erneute Einladung ist möglich.",
			roleChanged: "Rolle von {name} geändert.",
		},
	},
	env: {
		title: "Umgebungsvariablen",
		name: "Name",
		value: "Wert",
		saved: "Umgebungsvariablen gespeichert.",
		empty: "Keine Variablen zu setzen",
		noBuild:
			"Der Build dieser Projektversion deklariert keine Variablen, oder sie wurde noch nicht gebaut.",
		resizeName: "Breite der Namensspalte",
		removeStale: "{name} entfernen",
		notSet: "nicht gesetzt",
		defaultWithheld: "Server-Standard zurückgehalten",
		defaultWithheldWhy:
			"Das Gateway-Token des Servers geht nur an das Gateway des Servers, und NOTITIA_LLM_GATEWAY_URL dieses Dataspace nennt ein anderes. Diese URL leeren, um das Gateway des Servers und sein Token zu nutzen, oder ein eigenes Token für diesen Dataspace eintragen.",
		serverDefault: "Server-Standard",
		overridesDefault: "Ersetzt Standard",
		defaultRefused: "Standard nicht genutzt",
		useDefault: "Server-Standard für {name} verwenden",
		refuseDefault: "Server-Standard für {name} nicht verwenden",
		defaultsNote:
			"Server-Standards kommen aus dem Kontrollzentrum. Ein leeres Feld nutzt seinen Standard, der grau angezeigt wird. Laufende Prozesse behalten die Werte, mit denen sie gestartet wurden; der nächste Start oder Neustart übernimmt die neuen.",
		stale: {
			title: "Veraltete Variablen",
			hint: "Diese Variablen sind gespeichert, werden aber im aktuellen Build nicht mehr deklariert. Sie werden beim Speichern entfernt.",
		},
		outdated: {
			title: "{n} laufender Prozess nutzt noch die vorherigen Werte | {n} laufende Prozesse nutzen noch die vorherigen Werte",
			note: "Ein laufender Prozess behält die Werte, mit denen er gestartet wurde; ein Neustart übernimmt die neuen.",
			saveFirst: "Speichern Sie zuerst Ihre Änderungen, damit der Neustart sie übernimmt.",
			restartAll: "Alle laufenden neu starten",
			confirmTitle: "{n} laufenden Prozess neu starten? | {n} laufende Prozesse neu starten?",
			confirmNote:
				"Jeder setzt dort fort, wo er angehalten wurde, mit den neuen Werten. Ein Prozess, dessen Build keine Fortsetzungsfunktion hat, beginnt von vorn, und was er gerade hält, geht verloren. Neustart-Regeln gelten hier nicht — auch ein Prozess, dessen Regel keinen Neustart erlaubt, wird neu gestartet. Ein Neustart ändert nie die Version eines Prozesses; eine Aktualisierung ist ein eigener Schritt und übernimmt den Zustand nur bestmöglich.",
			confirm: "Neu starten",
			restarted: "{n} Prozess neu gestartet. | {n} Prozesse neu gestartet.",
			nothing: "Kein Prozess musste mehr neu gestartet werden.",
		},
	},
};
